import React, { useState } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import "./GenreChips.css";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";

export const GenreChips = (props) => {
  const [genreToggle, setGenreToggle] = useState(false);
  const { onClickGenre, name, keyValue, genreNameArr } = props;

  const genrefunction = () => {
    setGenreToggle(!genreToggle);
    onClickGenre();
  };
  return (
    <Box
      key={keyValue}
      className={genreNameArr.includes(name) ? "on-select" : "on-deselect"}
      component="button"
      onClick={() => genrefunction()}
      fontSize="14px"
      fontWeight="400"
    >
      {name}
    </Box>
  );
};

export const GenreChips2 = (props) => {
  const { onClickAge, active, name, keyValue } = props;
  return (
    <Box
      key={keyValue}
      className={active ? "on-select" : "on-deselect"}
      component="button"
      onClick={onClickAge}
      fontSize="14px"
      fontWeight="400"
    >
      {name}
    </Box>
  );
};

export function GenreChips3(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState("View Count");
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setValue("Release Date");
    props.handleChange("releaseDate");
  };
  const handleClose2 = () => {
    setAnchorEl(null);
    setValue("View Count");
    props.handleChange("viewCount");
  };

  return (
    <div>
      <Box
        component="button"
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="on-select"
      >
        <span className="rotate-icon">
          <CompareArrowsIcon />
          {value}
        </span>
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClose}>Release date</MenuItem>
        <MenuItem onClick={handleClose2}>View count</MenuItem>
      </Menu>
    </div>
  );
}
